var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_9613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.281738C3.95117 0.281738 0.265625 4.18408 0.265625 9.00049C0.265625 13.8169 3.95117 17.7192 8.5 17.7192C13.0488 17.7192 16.7344 13.8169 16.7344 9.00049C16.7344 4.18408 13.0488 0.281738 8.5 0.281738ZM10.3959 12.5899L7.46738 10.3364C7.36445 10.2556 7.30469 10.129 7.30469 9.99541V4.07861C7.30469 3.84658 7.48398 3.65674 7.70312 3.65674H9.29688C9.51602 3.65674 9.69531 3.84658 9.69531 4.07861V8.91963L11.8037 10.5438C11.983 10.681 12.0195 10.9446 11.89 11.1345L10.9537 12.4985C10.8242 12.6849 10.5752 12.7271 10.3959 12.5899Z",
    fill: "#465856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_9613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock2.416b28dafa2f52ac55ae0741e8ad6867.svg";
export { ForwardRef as ReactComponent };